// extracted by mini-css-extract-plugin
module.exports = {"card":"TaskCard_card__Pju7t","card_iconContainer":"TaskCard_card_iconContainer__b_7d0"};